import React from 'react'
import {InputNumber} from 'antd'

export default function NumericInput() {
  return <InputNumber size="large"></InputNumber>
}
